import React, { MouseEventHandler } from 'react'
import { Box, SxProps, Theme } from '@mui/material'

interface ResactlyCardProps {
  children: React.ReactNode
  active?: boolean
  height?: string
  width?: string
  noBorder?: boolean
  padding?: number | string
  sx?: SxProps<Theme>
  onClickAction?: MouseEventHandler | undefined
}

const ResactlyCard: React.FC<ResactlyCardProps> = ({
  children,
  active,
  height = 'auto',
  width = 'inherit',
  noBorder = false,
  padding = 2,
  sx,
  onClickAction,
}) => {
  return (
    <Box
      border={noBorder ? 0 : 2}
      borderColor={active ? 'grey.800' : 'grey.200'}
      p={padding}
      borderRadius="12px"
      onClick={onClickAction}
      sx={{
        filter: active ? 'drop-shadow(0px 2px 4px 0px #6666664D)' : 'none',
        backgroundColor: 'common.white',
        height,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: width,
        width: '100%',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default ResactlyCard
